<template>
<div class="txtValidationMessage">Your selected Delivery Address is incomplete. Please edit it in Address Book before proceeding further. <a href="profile#address-book" class="hypIndiaBazaar">Edit Address</a></div>
</template>
<script>
export default {
  name: "ValidationMessage",
};
</script>